// extracted by mini-css-extract-plugin
export default {"dateRangeSeparator":"DateRangeInput_dateRangeSeparator__LW40-"};